import { useState } from "react";
import SimpleReactValidator from "simple-react-validator";

const useValidator = (customMessage = {}, customValidator = {}) => {
  const [show, setShow] = useState(false);
  const validator = new SimpleReactValidator({
    className: "text-danger",
    messages: customMessage,
    validators: customValidator
  });

  const triggerValidation = () => {
    setShow(true);
  };

  if (show) {
    validator.showMessages();
  }

  return [validator, triggerValidation];
};

export default useValidator;
